// Private proof bytes live only in this mounted order's memory. Never persisted.
// A cache hit is only a candidate: the server must reauthorize and validate it
// on every open before the caller may display the image.
export const PROOF_VERSION = /^[a-f0-9]{64}$/;
export function createProofMemoryCache({ maxEntries = 3, maxBytes = 8 * 1024 * 1024, ttlMs = 5 * 60 * 1000, now = Date.now } = {}) {
  const entries = new Map();
  let bytes = 0;
  function remove(key) {
    const entry = entries.get(key);
    if (entry) bytes -= entry.bytes;
    entries.delete(key);
  }
  function prune() {
    const time = now();
    for (const [key, entry] of entries) if (time - entry.createdAt >= ttlMs || time < entry.createdAt) remove(key);
  }
  return {
    get(key) {
      prune();
      const entry = entries.get(key);
      if (!entry) return null;
      entries.delete(key); entries.set(key, entry);
      return entry;
    },
    put(key, value) {
      prune(); remove(key);
      if (!PROOF_VERSION.test(value?.version || '') || typeof value?.src !== 'string') return;
      // Conservative UTF-16 string accounting; decoded browser pixels are separate.
      const size = value.src.length * 2;
      if (size > maxBytes || maxEntries < 1) return;
      while (entries.size && (entries.size >= maxEntries || bytes + size > maxBytes)) remove(entries.keys().next().value);
      entries.set(key, { version: value.version, src: value.src, mime_type: value.mime_type, bytes: size, createdAt: now() });
      bytes += size;
    },
    remove,
    clear() { entries.clear(); bytes = 0; },
  };
}
